<template>
  <a :href="parentLoginUrl">
    <svg xml:space="preserve" viewBox="0 0 511.999 511.999" style="width: 35px">
      <path
        fill="#ff905e"
        d="M470.856 483.152H41.143c-31.629 0-51.393-34.215-35.574-61.616L220.426 49.395c15.814-27.391 55.327-27.401 71.147 0L506.43 421.536c15.813 27.391-3.934 61.616-35.574 61.616z"
      />
      <path fill="#e87e04" d="M506.43 421.536 291.573 49.395c-7.304-12.65-20.484-20.539-35.574-20.539v454.296h214.857c31.628 0 51.394-34.214 35.574-61.616z" />
      <g fill="#ffe49c">
        <path
          d="M256 330.523c-10.394 0-18.821-8.427-18.821-18.821v-107.89c0-10.394 8.427-18.821 18.821-18.821s18.821 8.427 18.821 18.821v107.89c0 10.395-8.427 18.821-18.821 18.821zM256 403.855c-10.394 0-18.821-8.427-18.821-18.821v-11.239c0-10.394 8.427-18.821 18.821-18.821s18.821 8.427 18.821 18.821v11.239c0 10.394-8.427 18.821-18.821 18.821z"
        />
      </g>
      <g fill="#ffc72d">
        <path
          d="M256 184.991v145.533c10.394 0 18.821-8.427 18.821-18.821v-107.89c0-10.395-8.427-18.822-18.821-18.822zM256 354.974v48.881c10.394 0 18.821-8.427 18.821-18.821v-11.239c0-10.394-8.427-18.821-18.821-18.821z"
        />
      </g>
    </svg>
    <div class="text-left">
      <div class="mb-1"><strong>Login as a parent?</strong></div>
      <div style="line-height: 1rem"><small>Click here to go to Kagami Parent Portal.</small></div>
    </div>
  </a>
</template>

<script>
import { getParentSiteBase } from '@/helper/util_custom'

export default {
  data() {
    return {
      parentLoginUrl: `${getParentSiteBase()}/login`,
    }
  },
}
</script>

<style scoped>
a {
  border: 1px solid #eb5353;
  border-left: 5px solid #eb5353;
  box-shadow: 2px 2px 5px lightgray;
  border-radius: 5px;
  color: #eb5353;
  padding: 6px 15px;
  display: flex;
  gap: 15px;
  align-items: center;
}
a:hover {
  background-color: #eb535310;
  box-shadow: none;
}
</style>
